import React, { Dispatch, SetStateAction } from 'react';
import { TouchableOpacity } from 'react-native';
import Colors from '../../../constants/Colors';
import CompareArrowsIcon from '../../CompareArrowsIcon';

interface CompareButtonProps {
  dateSelected: boolean,
  setDateSelected: Dispatch<SetStateAction<boolean>>,
  onOpen,
  logEvent,
  comparing: boolean,
}

const CompareButton = ({
  dateSelected, setDateSelected, onOpen, logEvent, comparing,
}: CompareButtonProps) => {
  let borderColor: string = dateSelected
    ? Colors.light.hereworksLightBlue : Colors.light.hereworksPaleBlue900;
  if (comparing) {
    borderColor = dateSelected ? Colors.light.hereworksYellow600 : Colors.light.hereworksYellow700;
  }

  return <TouchableOpacity
    style={{
      backgroundColor: '#fff',
      width: 40,
      height: 40,
      borderWidth: 1.5,
      borderColor,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
    }}
    onPress={() => {
      onOpen(!dateSelected);
      setDateSelected(!dateSelected);
      logEvent('DateComponent', 'Compare');
    }}
  >
    <CompareArrowsIcon color={comparing
      ? Colors.light.hereworksYellow600 : Colors.light.hereworksBlue500} />
  </TouchableOpacity>;
};

export default CompareButton;
